export default __webpack_public_path__ + "static/media/enghien12.aa0caaec.jpg";